import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase/config';
import { auth } from '../firebase/config';

export const trackEvent = async (eventName: string, parameters?: Record<string, any>) => {
  try {
    const analyticsInstance = await analytics;
    if (analyticsInstance) {
      // Get current user to include user ID in events
      const currentUser = auth.currentUser;
      const enhancedParams = {
        ...parameters,
        ...(currentUser && { user_id: currentUser.uid })
      };

      logEvent(analyticsInstance, eventName, enhancedParams);
      console.log(`Analytics event tracked: ${eventName}`, enhancedParams);
    }
  } catch (error) {
    console.error('Error tracking analytics event:', error);
  }
};

// Predefined events
export const trackSessionStart = () => {
  trackEvent('session_start', {
    timestamp: new Date().toISOString(),
    platform: 'web'
  });
};

export const trackMeditationComplete = (meditationId: string, duration: number, type?: string) => {
  trackEvent('meditation_complete', {
    meditation_id: meditationId,
    duration_seconds: duration,
    type: type || 'unknown',
    timestamp: new Date().toISOString()
  });
};

export const trackMeditationStart = (meditationId: string, type?: string) => {
  trackEvent('meditation_start', {
    meditation_id: meditationId,
    type: type || 'unknown',
    timestamp: new Date().toISOString()
  });
};

export const trackUserLogin = (method: string) => {
  trackEvent('user_login', {
    method,
    timestamp: new Date().toISOString()
  });
};

export const trackUserLogout = () => {
  trackEvent('user_logout', {
    timestamp: new Date().toISOString()
  });
};

export const trackReferralSource = (source: string) => {
  trackEvent('referral_source_selected', {
    source,
    timestamp: new Date().toISOString()
  });
};

export const trackReferralCodeApplied = (code: string, affiliateName?: string) => {
  trackEvent('referral_code_applied', {
    code,
    affiliate_name: affiliateName,
    timestamp: new Date().toISOString()
  });
};
